import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import './MainLayout.css';

export default function MainLayout({ userData, handleLogout, isAuthenticated }) {
  const [open, setOpen] = useState(true);

  return (
    <div className="app-shell">
      <Header open={open} onClose={() => setOpen(!open)} />
      <Sidebar open={open} onClose={() => setOpen(false)} userData={userData} handleLogout={handleLogout} isAuthenticated={isAuthenticated} />
      <main className="main-content">
        <div className="content-wrapper">
          <Outlet />
        </div>
      </main>
      <Footer />
    </div>
  );
}
